import { useAuth } from "context/AuthContext";
import { useState } from "react";
import styled from "styled-components";
import { ReportModal } from "ui/base/class/components/ReportModal";
import { ReviewModal } from "ui/base/class/components/ReviewModal";
import { PastClassCard } from "ui/base/class/PastClassCard";
import { hideScrollBar } from "ui/base/scrollbarStyle/scrollbarStyle";
import { fonts, mediaSizes } from "ui/theme";
import { PrevButton } from "ui/base/Button/EmblaButtons";
import { userRoute } from "../../user.routes";
import { useNavigate } from "react-router-dom";
import { NoContent } from "ui/base/NoContent/NoContent";
import { LoaderComponent } from "ui/base/loading/LoaderComponent";
import NoPastClasses from "ui/icons/not-found-icons/noPastClasses.svg"

export const PastClasses = ({ pastClasses, setTabToNull, isPastClassesLoading }) => {
    const navigate = useNavigate();
    const [selectedClass, setSelectedClass] = useState(null);

    const [isReviewModalVisible, setShowReviewModal] = useState(false);
    const [isReportModalVisible, setShowReportModal] = useState(false);

    const { token } = useAuth();

    const showReportModal = () => {
        if (!token) {
            setShowLoginModal(true);
            return;
        }
        setShowReportModal(true);
    };

    return (
        <>
            {selectedClass && isReviewModalVisible ? (
                <ReviewModal
                    show={isReviewModalVisible}
                    handleClose={() => {
                        setSelectedClass(null);
                        setShowReviewModal(false);
                    }}
                    selectedClass={selectedClass}
                />
            ) : null}

            {selectedClass && isReportModalVisible ? (
                <ReportModal
                    isVisible={isReportModalVisible}
                    onClose={() => {
                        setSelectedClass(null);
                        setShowReportModal(false);
                    }}
                    classDetail={selectedClass}
                />
            ) : null}

            <Content>
                <HeaderTitleContainer>
                    <PrevButton onClick={setTabToNull} />
                    <HeaderTitle>Past Classes</HeaderTitle>
                </HeaderTitleContainer>
                <ClassList>
                    {isPastClassesLoading ? (
                        <LoadingContainer>
                            <LoaderComponent minHeight="auto" />
                        </LoadingContainer>
                    ) : pastClasses.length
                        ? pastClasses?.map((pastClass) => (
                            <PastClassCard
                                pastClass={pastClass}
                                key={pastClass.id}
                                onReview={() => {
                                    setSelectedClass(pastClass);
                                    setShowReviewModal(true);
                                }}
                                onReport={() => {
                                    setSelectedClass(pastClass);
                                    showReportModal();
                                }}
                                onRehire={() => {
                                    navigate(userRoute.showMoreDates + pastClass?.teacher_user_id)
                                }}
                            />
                        ))
                        : <div style={{ gridColumn: "1 / -1", paddingTop: '2rem' }}>
                            <NoContent
                                title='No past classes found'
                                image={NoPastClasses}
                                size={280} />
                        </div>}
                </ClassList>
            </Content>
        </>
    );
};

const Content = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    overflow-y: scroll;
    gap: 1rem;
    height: 100%;
    padding-bottom: 1.5rem;
    ${hideScrollBar} ;
    @media (width >= ${mediaSizes.lg}) {
        gap: 1.5rem;
    }
`;

const ClassList = styled.div`
    display: grid;
    gap: 0.8rem;

    & > div {
        height: fit-content;
    }

    grid-template-columns:1fr;
    @media (width >= ${mediaSizes.lg}) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const HeaderTitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1.2rem;
    margin-bottom: 1.8rem;

    @media (width >= ${mediaSizes.md}) {
        display: none;
    }
`

const HeaderTitle = styled.div`
    font-size: ${fonts.sizes.big};
    font-weight: 600;

    @media (width >= ${mediaSizes.md}) {
        font-size: ${fonts.sizes.h4};
    }
    @media (width >= ${mediaSizes.lg}) {
        font-size: ${fonts.sizes["h3.4"]};
    }
`

const LoadingContainer = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    align-content: center;
    text-align: center;
`;

